import * as React from "react";

export function GetDreamRowLayoutStyle({
    shouldShowNameExpansion,
    isNameExpanded,
    opacity,
}: {
    shouldShowNameExpansion: boolean;
    isNameExpanded: boolean;
    opacity: number;
}): React.CSSProperties {
    return {
        display: shouldShowNameExpansion ? `grid` : `flex`,
        gridTemplateColumns: shouldShowNameExpansion
            ? `auto minmax(0, 1fr) 24px`
            : undefined,
        alignItems: isNameExpanded ? `stretch` : `center`,
        columnGap: `3px`,
        rowGap: `3px`,
        justifyContent: `flex-start`,
        width: `100%`,
        maxWidth: `100%`,
        margin: `0`,
        minWidth: 0,
        whiteSpace: `nowrap`,
        opacity,
    };
}
